if (!customElements.get('localization-drawer')) {
  class LocalizationDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.localization-drawer__inner')) this.close();
      });
      this.setTriggerAccessibility();
    }

    setTriggerAccessibility() {
      const trigger = document.getElementById('localization-drawer-trigger');
      if (!trigger) return;

      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'LocalizationDrawer');

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(trigger);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) {
        this.activeElement = triggeredBy;
        triggeredBy.setAttribute('aria-expanded', 'true');
      }
      setTimeout(() => {
        this.classList.add('active');
      });
      this.addEventListener(
        'transitionend',
        () => {
          trapFocus(document.getElementById('LocalizationDrawer'), this.querySelector('.localization-drawer__inner'));
        },
        { once: true }
      );
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      if (this.activeElement) this.activeElement.setAttribute('aria-expanded', 'false');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('localization-drawer', LocalizationDrawer);
}
